import { DocumentLine } from "api";
import { valueOr } from "./statHelpers";

export const getProductName = (
  documentLines: DocumentLine[] | null | undefined
) => {
  const itemShortName = documentLines?.[0]?.ItemShortName;
  const itemName = documentLines?.[0]?.ItemName;

  return itemShortName === "" ? valueOr(itemName) : valueOr(itemShortName);
};
